<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPageLoader" :color="loaderColor" :blur="''"></loading>
    <div>
      <v-wait for="purchases">
        <half-circle-spinner slot="waiting" style="display: block; margin: 0 auto;" :animation-duration="1000" :size="60" color="#3d4852" />
        <div class="flex flex-col w-full bg-white rounded">
          <div class="px-4 py-3 border-solid border-grey-200 border-b">
            <h4 class="font-semibold text-grey-700">{{ $t('frontend_groovesell_billing_setting') }}</h4>
            <div class="text-sm text-grey-700">{{ $t('frontend_groovesell_billing_sett_conf') }}</div>
          </div>
          <div class="p-4">
            <h5 class="font-semibold text-grey-700">Transactions</h5>
            <step2 ref="step2" :purchases="purchases"></step2>
          </div>
        </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import Swal from 'sweetalert2';
import Loading from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css'
import { Card, instance } from 'vue-stripe-elements-plus';
import axios from 'axios';
import { required, requiredIf, numeric, minLength, maxLength, alpha, alphaNum, email, sameAs } from 'vuelidate/lib/validators';
import Cleave from 'vue-cleave-component';
import step2 from './step2';

const touchMap = new WeakMap();

export default {
  middleware: 'auth',
  layout: 'default',
  components: {
    step2,
    Loading,
    Card,
    Cleave,
  },
  data() {
    return {
      tabs: [
        {
          title: '<span class="text-sm">Info<span>',
          value: this.$t('frontend_groovesell_billing_your_access_level')
        },
        {
          title: `<span class="text-sm">${this.$t('frontend_transactions')}<span>`,
          value: this.$t('frontend_transactions')
        }
      ],
      currentTab: this.$t('frontend_groovesell_billing_your_access_level'),
      accessLevel: null,
      processing_payment: false,
      nextBillingDate: null,
      purchases: [],
      purchasesTableColumns: ['product_name', 'human_readable_price', 'formatted_date_time', 'current_status'],
      purchasesTableOptions: {
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc'
        },
        sortable: ['product_name'],
        headings: {
          product_name: this.$t('frontend_product'),
          human_readable_price: this.$t('frontend_price'),
          current_status: this.$t('frontend_status'),
          formatted_date_time: this.$t('frontend_groovesell_billing_date_and_time')
        },
        filterByColumn: false,
        filterable: false,
        childRowTogglerFirst: false,
        perPage: 10000,
        rowClassCallback() {
          return 'hover:bg-grey-50 funnelRow';
        }
      },
      purchaseDetailTabs: [
        { title: this.$t('frontend_transaction'), value: 'transaction' },
        { title: this.$t('frontend_customer'), value: 'customer' },
        { title: this.$t('frontend_affiliate'), value: 'affiliate' }
      ],
      purchaseDetailsTab: 'transaction',
      fullPageLoader: true,
      isLoading: false,
      domLayout: 'autoHeight',
      loaderColor: '#FD6481',
      complete: true,
      creditCardGatewayType: null,
      creditCardGatewayId: 0,
      stripePublishableKey: null,
      stripeIntentSecret: null,
      cardNumberOptions: {
        creditCard: true
      },
      stripeUIOptions: {
        classes: {},
        style: {
          base: {
            color: '#32325d',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      },
      authNetClientKey: null,
      authNetLoginId: null,
      card: {
        name: '',
        number: '',
        cvv: '',
        expirationYear: new Date().getFullYear(),
        expirationMonth: '01'
      },
      payment_info_form: new Form({
        paymentMethodId: null,
        setupIntentClientSecret: null,
        authNetDataDescriptor: null,
        authNetDataValue: null,
        gatewayType: null
      }),
      selectedTransactionId: 0,
      purchaseDetail: {
        id: null,
        buyer_fname: null,
        buyer_lname: null,
        buyer_phone: null,
        buyer_company: null,
        buyer_address: null,
        buyer_city: null,
        buyer_country: null,
        buyer_state: null,
        buyer_postal_code: null
      },
      genericUrl: `${window.config.apiUrl.split('/api')[0]}/api`,
    };
  },
  computed: {
    country_select_classes() {
      return 'w-full px-4 h-10 text-grey-600 outline-none rounded-lg border border-solid border-grey-200 rounded-lg bg-white';
    },
    mainTabClass() {
      if (this.currentTab == 'step1') {
        return 'pb-4 gs-default-tabs-item';
      } 
        return 'pb-4 gs-default-tabs-item';
      
    },

    region_select_classes() {
      return 'w-full px-4 h-10 text-grey-600 outline-none rounded-lg border border-solid border-grey-200 rounded-lg bg-white';
    },
    next10Years() {
      const currentYear = new Date().getFullYear();
      const yearsArray = [];

      for (let i = currentYear; i <= currentYear + 10; i++) {
        yearsArray.push(i);
      }

      return yearsArray;
    },

    is_paynow_button_disabled() {
      if (this.processing_payment || !this.complete) {
        return true;
      } 
        return false;
      
    }
  },
  async created() {
    this.$wait.start('purchases');
    const mainAppUrl = `${window.config.apiUrl.split('/api')[0]}/api`;
    try {
      if (this.$store.getters.isPlatinumUser) {
        this.accessLevel = 'Platinum Lifetime User';
      } else if (this.$store.getters.isGroovePagesUser) {
        this.accessLevel = 'Groovepages User';
      } else {
        this.accessLevel = 'Free User';
      }
      const { data } = await axios.get(`${mainAppUrl}/groovesell/purchases`);
      if (data.status == 'success') {
        this.purchases = data.purchases;
      } else {
        Swal.fire(this.$t('frontend_error'), this.$t('frontend_analytics_billing_unable_load_pur'), 'error');
      }
    } catch (e) {
      Swal.fire(this.$t('frontend_error'), this.$t('frontend_analytics_billing_unable_load_pur'), 'error');
    }

    const nextBillingDateRequest = await axios.get(`${mainAppUrl}/groovesell/get-next-transaction-date`);

    const nextBillingData = nextBillingDateRequest.data;

    if (nextBillingData.status == 'success') {
      this.nextBillingDate = nextBillingData.next_transaction_date;
    } else {
      this.nextBillingDate = null;
    }

    this.$wait.end('purchases');
  },
  methods: {
    handlePurchaseDetailTabChange(newTab) {
      this.purchaseDetailsTab = newTab;
    },
    handleStep2TabChange(newTab) {
      this.currentTab = newTab;
    },

    async reloadData() {
      this.$wait.start('purchases');
      try {
        const { data } = await axios.get(`${this.genericUrl}/groovesell/purchases`);
        if (data.status == 'success') {
          this.purchases = data.purchases;
        } else {
          Swal.fire(this.$t('frontend_error'), this.$t('frontend_analytics_billing_unable_load_pur'), 'error');
        }
      } catch (e) {
        Swal.fire(this.$t('frontend_error'), this.$t('frontend_analytics_billing_unable_load_pur'), 'error');
      }
      this.$wait.end('purchases');
    },

    async updatePaymentInfo(transactionId) {
      const paymentInfo = {};
      const self = this;

      self.showLoader();

      await axios
        .get(`${this.genericUrl}/groovesell/fetch-transaction-payment-info`, {
          params: { transaction_id: transactionId }
        })
        .then(({ data }) => {
          self.selectedTransactionId = transactionId;
          self.creditCardGatewayType = data.card_gateway_type;

          if (self.creditCardGatewayType == 'stripe') {
            self.complete = false;
            self.stripePublishableKey = data.card_gateway_public_details.publishable_key;
            self.stripeIntentSecret = data.card_gateway_public_details.setupintent_secret;
          } else if (self.creditCardGatewayType == 'authorize.net') {
            self.complete = true;
            self.authNetClientKey = data.card_gateway_public_details.client_key;
            self.authNetLoginId = data.card_gateway_public_details.api_login_id;
          }

          this.$root.$emit('modal-open', 'update-payment-info-modal');

          self.hideLoader();
        })
        .catch(error => {
          self.hideLoader();
          Swal.fire({
            type: 'error',
            title: this.$t('frontend_error'),
            text: this.$t('frontend_analytics_billing_unable_fetch_pay_info')
          });
        });
    },

    async downloadTransactionInvoice(transactionId) {
      const self = this;
      self.showLoader();
      const invoiceLinkData = await axios.post(`${this.genericUrl}/groovesell/generate-invoice-download-link`, {
        transaction_id: transactionId
      });
      

      let a = document.createElement('a');
      a.href = invoiceLinkData.data.download_link.replace(/^http:\/\//i, 'https://');
      a.click();


      self.hideLoader();
    },

    async updateCardDetails() {
      if (!this.is_paynow_button_disabled) {
        const self = this;

        const { value: accept } = await Swal.fire({
          title: this.$t('frontend_sure'),
          text: this.$t('frontend_groovesell_swal_update_your_payment_info'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('frontend_groovesell_swal_btn_confirm_update_payment_info')
        });

        if (accept) {
          if (this.creditCardGatewayType == 'stripe' && this.complete) {
            self.processing_payment = true;
            await this.submitFormToCreatePaymentMethod();
          } else {
            this.$v.card.$touch();
            const cardIsValid = !this.$v.card.$invalid;

            if (cardIsValid) {
              self.processing_payment = true;

              const authData = {};
              authData.clientKey = this.authNetClientKey;
              authData.apiLoginID = this.authNetLoginId;

              const cardData = {};
              cardData.cardNumber = this.card.number;
              cardData.month = this.card.expirationMonth;
              cardData.year = this.card.expirationYear;
              cardData.cardCode = this.card.cvv;

              const secureData = {};
              secureData.authData = authData;
              secureData.cardData = cardData;
              await Accept.dispatchData(secureData, this.authorizeResponseHandler);
            } else {
              self.processing_payment = false;
            }
          }
        }
      }
    },

    async submitFormToCreatePaymentMethod() {
      const se = this.$refs.stripeCard.$refs.element;
      const self = this;

      self.showLoader();
      instance
        .confirmCardSetup(self.stripeIntentSecret, {
          payment_method: {
            card: se._element
          }
        })
        .then(async result => {
          const mainAppUrl = `${window.config.apiUrl.split('/api')[0]}/api`;

          if (result.error) {
            Swal.fire({
              type: 'error',
              title: this.$t('frontend_error'),
              text: this.$t('frontend_analytics_billing_unable_to_process_card')
            });

            self.processing_payment = false;
            self.hideLoader();
          } else {
            self.payment_info_form.transactionId = self.selectedTransactionId;
            self.payment_info_form.gatewayType = 'card';
            self.payment_info_form.paymentMethodId = result.setupIntent.payment_method;
            self.payment_info_form.setupIntentClientSecret = self.stripeIntentSecret;

            const captureUrl = `${mainAppUrl}/update-payment-info`;
            const payment_request_data = await self.payment_info_form.post(captureUrl);
            const payment_data = payment_request_data.data;

            const payment_status = payment_data.status;

            if (payment_status == 'captured') {
              self.processing_payment = false;
              self.hideLoader();

              const { value: accept } = await Swal.fire(
                this.$t('frontend_analytics_billing_pay_info_updated'),
                this.$t('frontend_analytics_billing_pay_info_trans_updated'),
                'success'
              );

              if (accept) {
                self.$root.$emit('modal-close', 'update-payment-info-modal');
              }
            } else {
              self.processing_payment = false;
              self.hideLoader();

              const { value: accept } = await Swal.fire(
                this.$t('frontend_analytics_billing_pay_info_unsuccess'),
                this.$t('frontend_analytics_billing_pay_info_trans_unsuccess'),
                'error'
              );

              if (accept) {
                self.$root.$emit('modal-close', 'update-payment-info-modal');
              }
            }
          }
        });
    },

    async authorizeResponseHandler(response) {
      this.showLoader();
      if (response.messages.resultCode === 'Error') {
        Swal.fire({
          type: 'error',
          title: this.$t('frontend_error'),
          text: this.$t('frontend_analytics_billing_unable_to_process_card')
        });

        this.processing_payment = false;
        this.hideLoader();
      } else {
        const self = this;
        self.payment_info_form.transactionId = self.selectedTransactionId;
        self.payment_info_form.gatewayType = 'card';
        self.payment_info_form.authNetDataDescriptor = response.opaqueData.dataDescriptor;
        self.payment_info_form.authNetDataValue = response.opaqueData.dataValue;
        const captureUrl = `${window.config.grooveapisUrl  }/api/groovesell/self-billing/update-payment-info`;
        const payment_request_data = await self.payment_info_form.post(captureUrl);
        const payment_data = payment_request_data.data;

        const payment_status = payment_data.status;

        if (payment_status == 'captured') {
          self.processing_payment = false;
          self.hideLoader();

          const { value: accept } = await Swal.fire(
            this.$t('frontend_analytics_billing_pay_info_updated'),
            this.$t('frontend_analytics_billing_pay_info_trans_updated'),
            'success'
          );

          if (accept) {
            self.$root.$emit('modal-close', 'update-payment-info-modal');
          }
        } else {
          self.processing_payment = false;
          self.hideLoader();

          const { value: accept } = await Swal.fire(
            this.$t('frontend_analytics_billing_pay_info_unsuccess'),
            this.$t('frontend_analytics_billing_pay_info_trans_unsuccess'),
            'error'
          );

          if (accept) {
            self.$root.$emit('modal-close', 'update-payment-info-modal');
          }
        }
      }
    },
    async updateProfile(transactionId) {
      const self = this;
      self.showLoader();
      const purchaseDeatai = await axios.post(`${this.genericUrl}/groovesell/purchase-detail`, {
        transaction_id: transactionId
      });
      self.purchaseDetail = purchaseDeatai.data.purchase[0];
      self.hideLoader();
      this.$root.$emit('modal-open', 'user-profile-modal');
    },
    async updateUserProfile() {
      this.$v.purchaseDetail.$touch();
      const isValid = !this.$v.purchaseDetail.$invalid;
      console.log(isValid);
      if (isValid) {
        const self = this;
        self.showLoader();
        const purchaseDetails = await axios.post(`${this.genericUrl}/groovesell/update-purchase-detail`, self.purchaseDetail);
        if (purchaseDetails.data.status == 'success') {
          const { data } = await axios.get(`${this.genericUrl}/groovesell/purchases`);
          if (data.status == 'success') {
            this.purchases = data.purchases;
          } else {
            Swal.fire(this.$t('frontend_error'), this.$t('frontend_analytics_billing_unable_load_pur'), 'error');
          }
          self.hideLoader();
          this.$root.$emit('modal-close', 'user-profile-modal');
        } else {
          Swal.fire({
            type: 'error',
            title: this.$t('frontend_error'),
            text: this.$t('frontend_groovesell_swal_billing_unable_update_details')
          });
          self.hideLoader();
        }
      }
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.gs-default-tabs-item:focus {
  outline: none !important;
  outline-style: none !important;
}
.disabled-button {
  background-color: #fea7b8 !important;
}

#purchases-list-view {
  .VueTables--client table {
    overflow: auto !important;
  }

  .VueTables__search-field {
    margin-bottom: 10px;
  }

  .VueTables__heading {
    color: #8f92ab;
  }

  .VueTables__sort-icon {
    color: #8f92ab;
    margin-left: 8px;
  }

  td {
    font-weight: 400;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .VueTables__child-row-toggler--closed::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 7l-.707031.707031 6.125 6.125 1.875 1.875 1.875-1.875 6.125-6.125-.707031-.707031-6.125 6.125-1.167969 1.167969-1.167969-1.167969-6.125-6.125' /></svg>");
    padding-right: 3px;
    vertical-align: middle;
    cursor: pointer;
  }

  .VueTables__child-row {
    text-align: center;
    border-bottom: 1px solid #ddd;
    border-left: 5px solid #fd6481;
  }

  .VueTables__child-row-toggler--open::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 1044.3622l-.707031-.707 6.125-6.125 1.875001-1.875 1.875 1.875 6.125 6.125-.707032.707-6.125-6.125-1.167968-1.168-1.167969 1.168-6.125 6.125' transform='translate(0-1030.3622)'/></svg>");
    padding-right: 3px;
    vertical-align: middle;
    cursor: pointer;
  }

  .VueTables__table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
  }

  .VueTables__row {
    border-bottom: 1px solid #ddd;
  }

  .VueTables__table th,
  td {
    text-align: left;
    padding: 16px;
  }

  tr.VueTables__child-row > td {
    padding: 0px !important;
  }

  thead {
    border-bottom: 1px solid #ddd;
  }

  .vue-pagination-ad {
    text-align: center;
  }

  .VueTables__limit {
    display: none;
  }

  .VuePagination__count {
    display: none;
  }

  .expandIcon {
    display: none;
  }

  .funnelRow:hover .expandIcon {
    display: block !important;
  }
}
</style>
